export default "__VITE_ASSET__DEZbvFYZ__"